// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"368":"bf96bb6da1dbe13264f5","6112":"07b65deb5e344adc9d8b","9338":"a17e15e4313835ef324d"}[chunkId] + ".chunk.css";
};